var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6598 36.0704C7.13622 33.2304 4.80647 29.1718 4.13112 24.697C3.45577 20.2221 4.48398 15.6567 7.01247 11.9034C9.54095 8.1501 13.3857 5.48209 17.7865 4.42687C22.1873 3.37165 26.8238 4.00602 30.7794 6.20457C34.735 8.40312 37.7218 12.0058 39.1491 16.3004C40.5765 20.5949 40.3406 25.2687 38.4881 29.3977C36.6356 33.5267 33.3012 36.8104 29.1444 38.5994C25.5944 40.1273 21.6652 40.4702 17.9327 39.6079C16.8669 39.3617 16.317 38.2262 16.6637 37.1888L19.2674 29.3977",
    stroke: "#354764",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1539 16.8096L21.8279 22.1933L12.7344 16.9418C12.8225 15.5665 13.9653 14.4775 15.3626 14.4775H28.5354C29.8887 14.4775 31.0046 15.4955 31.1539 16.8096ZM31.171 18.738V26.9334C31.171 28.3894 29.9915 29.5689 28.5354 29.5689H15.3626C13.9066 29.5689 12.7271 28.3894 12.7271 26.9334V18.8775L21.4119 23.8916C21.7104 24.0629 22.0702 24.0311 22.3296 23.8402C22.3418 23.8353 22.3516 23.828 22.3638 23.8206L31.171 18.738Z",
    fill: "#354764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.7ba22d81a52976e23558cfc2333b5ca5.svg";
export { ForwardRef as ReactComponent };